import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'dashboard/FETCH_REQUEST'
const FETCH_SUCCESS = 'dashboard/FETCH_SUCCESS'
const FETCH_FAILURE = 'dashboard/FETCH_FAILURE'

const initialState = {
  result: {
    company: {},
    companyLoaded: false, 
    asx200: {},
    asx200Loaded: false, 
    asx300: {},
    asx300Loaded: false, 
    superannuation: {},
    superannuationLoaded: false, 
  },
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadDashboardData(tab='company') {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('api/v1/dashboard/', {tab: tab}, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      const entity = payload.entity
      const entity_data = payload.entity_data
      let final_payload = state.result
      if (entity == 'company') {
        final_payload.company = entity_data
        final_payload.companyLoaded = true
      } else if(entity == 'asx200') {
        final_payload.asx200 = entity_data
        final_payload.asx200Loaded = true
      } else if(entity == 'asx300') {
        final_payload.asx300 = entity_data
        final_payload.asx300Loaded = true
      } else if(entity == 'superannuation') {
        final_payload.superannuation = entity_data
        final_payload.superannuationLoaded = true
      }
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: final_payload
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      })
    default:
      return state
  }
}

